import bigPoopImage from "../assets/poop.png";

export class BigMonster {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  hitboxX: number;
  hitboxY: number;
  hitboxWidth: number;
  hitboxHeight: number;

  constructor(randomX: number) {
    this.x = randomX;
    this.y = 0;
    this.width = 80;
    this.height = 80;
    this.image = new Image();
    this.image.src = bigPoopImage;

    this.hitboxX = this.x + 5;
    this.hitboxY = this.y + 5;
    this.hitboxWidth = 70;
    this.hitboxHeight = 70;
  }

  down(stage: number) {
    if (stage === 4) {
      this.y += 5;
      this.hitboxY += 5;
    } else if (stage === 5) {
      this.y += 5.5;
      this.hitboxY += 5.5;
    } else if (stage === 6) {
      this.y += 6;
      this.hitboxY += 6;
    } else if (stage === 7) {
      this.y += 7;
      this.hitboxY += 7;
    } else {
      this.y += 8;
      this.hitboxY += 8;
    }
  }

  draw(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = "red";
    // ctx.fillRect(
    //   this.hitboxX,
    //   this.hitboxY,
    //   this.hitboxWidth,
    //   this.hitboxHeight
    // );
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
